export default "__VITE_ASSET__DelSS0zb__"